import axios from "../../http_v2";
export default {
  exportApi:
    process.env.VUE_APP_API_ROOT +
    "activityservice/activitylive/netapi/live/info/excel",
  exportApi1:
    process.env.VUE_APP_API_ROOT +
    "activityservice/activitylive/netapi/bg/count/detail/export",
  getLive: params => {
    return axios.get("activityservice/video/modifyBaseInfo", params);
  },
  list: params => {
    return axios.post("activityservice/activitylive/bg/list", params);
  },
  add: params => {
    return axios.post("activityservice/activitylive/create", params);
  },
  update: params => {
    return axios.post("activityservice/activitylive/update", params);
  },
  getVideoInfo(params) {
    return axios.get("activityservice/video/get", params);
  },
  getVideoList(params) {
    return axios.get("activityservice/video/list", params);
  },
  del: params => {
    return axios.get("activityservice/activitylive/remove", params);
  },
  // 获取直播的数据
  liveData: params => {
    return axios.get("activityservice/activitylive/live/info", params);
  },
  // 未开播用户观看详情
  zhiboWeikaiDetail: params => {
    return axios.get("activityservice/activitylive/live/readview/info", params);
  },
  // 直播观看详情
  zhiboPvDetail: params => {
    return axios.get("activityservice/activitylive/live/view/info", params);
  },
  // 回看观看详情
  zhiboRecordDetail: params => {
    return axios.get("activityservice/activitylive/live/review/info", params);
  },
  // 获取直播推拉流地址
  getTuiLaInfo: params => {
    return axios.get("activityservice/activitylive/stream", params);
  },
  // 停止直播
  stopLive: params => {
    return axios.post("activityservice/activitylive/stop", params);
  },
  // 获取直播设置
  getLiveSetting: params => {
    return axios.post("activityservice/activitylive/setting", params);
  },
  // 获取直播聊天
  getChatList: params => {
    return axios.get("activityservice/activitylive/chat", params);
  },
  // 审核聊天
  auditChat: params => {
    return axios.post("activityservice/activitylive/chat/audit", params);
  },
  // 更新高级设置
  updateSetting: params => {
    return axios.post("activityservice/activitylive/setting", params);
  }
};
